module.exports = __webpack_public_path__ + "img/eco2.7f73065f.jpg";